import { type JSONInvoiceAdjustment } from '~/types/InvoiceAdjustment';

import api from './api';

export type JSONInvoiceAdjustmentResponse = {
  data: {
    results: JSONInvoiceAdjustment[];
  };
};

export const getInvoiceAdjustmentsOfInvoice = (invoiceId: string) =>
  api.request({
    method: 'GET',
    url: `/v1/invoices/${invoiceId}/adjustments`,
  });
